import { ColumnType } from 'antd/lib/table';

import { TTariffProfileGrid } from '../../../core/tariff-profile-grid';
import { TTariffType } from '../../../core/tariff-type';
import { TTerminalType } from '../../../core/terminal-type';
import { createDataMapTariffProfile } from './create-data-map-tariff';
import { TariffProfileCell } from './tariff-profile-cell';

import styles from './data-grid.module.css';

export type DataGridTariffRow = {
  terminalTypeId: TTerminalType['id'];
  tariffTypeId: TTariffType['id'];
  tariffTypeName: TTariffType['nameRu'];
};

export const createTableGridData = (data: TTariffProfileGrid) => {
  const dataMap = createDataMapTariffProfile(data);

  const tariffTypesRows = data.terminalTypes
    .reduce<DataGridTariffRow[]>((acc, terminalType) => {
      const tariffsWithTrainType: DataGridTariffRow[] = data.tariffTypes.map(
        (tariffType) => ({
          terminalTypeId: terminalType.id,
          tariffTypeId: tariffType.id,
          tariffTypeName: tariffType.nameRu,
        }),
      );

      return acc.concat(tariffsWithTrainType);
    }, [])
    .sort((a, b) => {
      if (a.terminalTypeId === b.terminalTypeId) {
        return a.tariffTypeId - b.tariffTypeId;
      }

      return a.terminalTypeId - b.terminalTypeId;
    });

  const firstTariffTypeId = [...data.tariffTypes].sort((a, b) => a.id - b.id)[0]
    .id;

  const terminalTypesMap = Object.fromEntries(
    data.terminalTypes.map((item) => [item.id, item]),
  );

  const terminalTypeCol: ColumnType<DataGridTariffRow> = {
    title: 'Канал продаж',
    key: 'terminalType',
    width: '1%',
    onCell: (row) => {
      // rows should be sorted by data.trainTypeId, then data.tariffId
      if (row.tariffTypeId === firstTariffTypeId) {
        return { rowSpan: data.tariffTypes.length };
      }

      return {
        rowSpan: 0,
      };
    },
    render: (_: any, row) => {
      return terminalTypesMap[row.terminalTypeId].name;
    },
  };

  const zoneCols: ColumnType<DataGridTariffRow>[] = data.tariffZones.map(
    (zone) => {
      return {
        title: zone.nameRu,
        key: `zone-${zone.id}`,
        width: '1%',
        onCell: (row) => {
          return {
            className: styles.cell,
            row, // pass row data for custom "GridCellComponent" component (for antd/<Table/> ). Used for find tariff in DataMap
            zoneId: zone.id,
          };
        },
        render: (_: any, row) => {
          return <TariffProfileCell row={row} zoneId={zone.id} />;
        },
      };
    },
  );

  const tariffsCol: ColumnType<DataGridTariffRow> = {
    width: '1%',
    title: 'Виды тарифов',
    dataIndex: 'tariffTypeName',
  };

  const cols = [terminalTypeCol, tariffsCol, ...zoneCols];
  const rows = tariffTypesRows;

  return { cols, rows, dataMap };
};

export type TariffTableGridData = ReturnType<typeof createTableGridData>;
